// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.policy .modal-dialog {
  position: absolute !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.policy .modal-content {
  position: absolute !important;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.policy .modal {
  overflow: hidden !important;
}

.fullscreen-modal {
  max-width: none !important;
  margin: 20px !important;
}`, "",{"version":3,"sources":["webpack://./packages/react-hook-schema/standard/src/lib/hooks/styles/modal.scss"],"names":[],"mappings":"AACE;EACE,6BAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AAAJ;AAGE;EACE,6BAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AADJ;AAIE;EACE,2BAAA;AAFJ;;AAMA;EACE,0BAAA;EACA,uBAAA;AAHF","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
